export const SET_LOADING_VALUE = "SET_LOADING_VALUE";


// WEBPACK FOOTER //
// ./src/redux/actions/networkActions.js